import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import CommonHeader from '../../util_components/common_header';
import SalesTaskForm from './form';

const LIST_PATH = '/sales-task-list';

// Standalone task detail view, opened via /sales-task-form?uuid=…. The form
// body (SalesTaskForm) currently renders from frontend stub data so the fields
// can be built up; the backend compute + payload get wired in later.
function SalesTaskFormPage() {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const uuid = params.get('uuid') || '';
  // Only show "Back to sales tasks" when opened from the list page
  // (?from=list), not from the student profile popup.
  const from_list = params.get('from') === 'list';

  return (
    <div>
      <CommonHeader title="Sales Task" />

      <section
        className="bg-surface-card rounded-lg shadow-sm border border-line"
        style={{ margin: '20px 5%', padding: '20px 24px' }}
      >
        {from_list ? (
          <button
            type="button"
            onClick={() => history.push(LIST_PATH)}
            className="inline-flex items-center gap-2 mb-4 text-sm font-medium text-blue-600 hover:underline"
            style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}
          >
            <FaArrowLeft size={12} /> Back to sales tasks
          </button>
        ) : null}

        {/* key remounts the form per task: Done/Skip-and-Next pushes the same
            route with a new ?uuid, and without a remount the previous task's
            local state (review notes, attachments) bleeds into the next one.
            location.state.reopen (the hold banner's Reopen) remounts the same task. */}
        {uuid ? (
          <SalesTaskForm key={`${uuid}:${location.state?.reopen || ''}`} uuid={uuid} />
        ) : (
          <div className="text-sm" style={{ color: 'var(--text-muted)' }}>
            Invalid link — a <code>uuid</code> query param is required.
          </div>
        )}
      </section>
    </div>
  );
}

export default SalesTaskFormPage;
